module.exports = __webpack_public_path__ + "img/favicon.50cba5cf.svg";